import { mapGetters } from 'vuex'
import DownloadModal from '@/components/DownloadModal'
import AccessRequestModal from '@/components/AccessRequestModal'
import * as CONSTANTS from "../constants.js";
import util from '@/util'
import phImage from "@/assets/app_placeholder.png";

export default {
    data: function() {
        return {
            CONSTANTS,
            displayModal: false,
            displayAccessRequestModal: false,
            placeHolder: phImage,
            linkData: null
        }
    },
    computed: {
        ...mapGetters(['getUser'])
    },
    components: {
        DownloadModal,
        AccessRequestModal
    },
    methods: {
        showModal() {
            this.displayModal = true
        },
        closeModal() {
            this.displayModal = false
        },
        showAccessRequestModal(linkData) {            
            this.displayAccessRequestModal = true
            this.linkData = linkData
        },
        closeAccessRequestModal() {
            this.displayAccessRequestModal = false
            this.linkData = null
        },
        userHasAccess(app) {

            if (app.access && !util.stringIsBlank(app.access.state)) {
                //if app access is for FTE only and username starts with "t_" (non-fte) then no access      
                if (app.access.state === 'fte' && this.getUser.userName.startsWith(CONSTANTS.USERNAME_PREFIX.TEMP)) {
                    return false
                        //if app access is unkown the do not display access
                } else if (app.access.state === 'unknown') {
                    return false
                        //if app access is no-access then user does not have access
                } else if (app.access.state === 'no-access') {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        hasLastAccess(app) {
            return app.access && !util.stringIsBlank(app.access.last_accessed)
        },
        hasNoAccess(app) {
            return app.access && (app.access.state === 'no-access' || app.access.state === 'no-access-source-system')
        },
        openRootLink(app, route) {

            if (app.root_link.type === this.CONSTANTS.ROOT_LINK_TYPES.DIRECT_DOWNLOAD) {
                this.showModal()
            } else if (app.root_link.type === this.CONSTANTS.ROOT_LINK_TYPES.AZURE_ACCESS_LINK){
                this.showAccessRequestModal(app.root_link)
            } else {
                this.trackEvent(`app_id=${app.id} title=${app.title} ref=${app.root_link.reference.link} type=root_link`);
                util.postActionClick(app, this.getUser.userName, route, app.root_link.reference, "link");

                //var target = app.root_link.reference.action ? app.root_link.reference.action : "_blank"
                //window.open(app.root_link.reference.link, target);
            }
        },
        hasEntitlementType(app) {
            return app.access && app.access.display_type && app.access.display_type.length > 0
        },
        /**
         * Download file from link when ready
         * ** This feature is deactivated. Currently, files download automatically **
         * @param {*} app 
         * @param {*} route 
         */
        openDownloadLink(app, route) {
            // if IE use ms blob
            if (window.navigator.msSaveOrOpenBlob) {
                var blob = new Blob([app.downloadData.request.response]);
                window.navigator.msSaveOrOpenBlob(blob, app.downloadData.filename);
            } else {
                var fileLink = document.createElement('a');
                fileLink.href = URL.createObjectURL(app.downloadData.request.response);
                fileLink.download = app.downloadData.filename;
                fileLink.click();

            }
            this.resetDownloadData(app)
        },
        getAppIcon(app) {
            if (!app || util.stringIsBlank(app.icon)) {
                return phImage
            } else {
                // if app icon starts with /image/ get it from apps-store
                if (app.icon.startsWith('/image/')) {
                    return process.env.VUE_APP_ASSET_BASE_URL + app.id + app.icon
                } else {
                    return app.icon
                }
            }
        },
        cancelDownload(app) {
            app.downloadData.request.abort()
            this.resetDownloadData(app)
        },
        resetDownloadData(app) {
            app.downloadData = {
                isDownloading: false,
                stateText: "",
                progress: 0,
                downloadReady: false,
                request: ""
            }
        },
        parseEntitlementString(str) {
            return util.parseEntitlementString(str)
        }
    }
}